import { useState } from 'react';
import { useTimereportSettings } from '../../Core/Hooks/admin/useTimereportSettings';
import TimereportCalendar from './TimeEntry/TimereportCalendar';
import TimereportHourSummary from './TimeEntry/TimereportHourSummary';
import TimereportRemindersList from './TimeEntry/TimereportRemindersList';
import TimereportDayView from './TimeEntry/TimereportDayView';
import TimereportWeekView from './TimeEntry/TimereportWeekView';
import './TimereportReportView.scss';

type ViewMode = 'day' | 'week';

const TimereportReportView = () => {
	const { settings } = useTimereportSettings();
	const [viewMode] = useState<ViewMode>(settings.mode || 'day');
	const [selectedDate, setSelectedDate] = useState<string | undefined>();

	return (
		<div className='biz-timereport-report-view'>
			<div className='biz-timereport-report-view__top-row'>
				<div className='biz-timereport-report-view__calendar'>
					<TimereportCalendar showTimereports={false} minimal={true} onSelectDate={setSelectedDate} />
				</div>
				<div className='biz-timereport-report-view__hour-summary'>
					<TimereportHourSummary hideWeekend={!settings.weekendDaysEnabled} selectedDate={selectedDate} />
				</div>
				<div className='biz-timereport-report-view__reminders'>
					<TimereportRemindersList hideEmptyList={true} />
				</div>
			</div>
			<div className='biz-timereport-report-view__bottom-row'>
				{viewMode === 'day' ? (
					<TimereportDayView selectedDate={selectedDate} />
				) : (
					<TimereportWeekView selectedDate={selectedDate} weekendEnabled={settings.weekendDaysEnabled} />
				)}
			</div>
		</div>
	);
};

export default TimereportReportView;
